'use strict';

import base from '~base';
import { handleSearchInput } from 'core/components/search';
import $ from 'jquery';

module.exports = function () {
    // Unbind existing search suggestion handlers to prevent duplicate requests
    $('input.search-field').off('keyup click');

    handleSearchInput();
    base();
    // Custom Start: Make cart product images responsive //
    const target = document.querySelector('.suggestions-wrapper');

    if (target) {
        const observer = new MutationObserver((mutationsList) => {
            if (target.innerHTML.length > 0) {
                if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
                    window.makeCloudinaryImagesResponsive();
                }
            }
        });

        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }
    // Custom End: Make suggested product images responsive //
};
